exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".value-4850abc6{color:#757575;margin:15px 0 5px 0}.apply-13e5984f{font-size:14px;font-weight:500}.DayPickerInput input{max-width:100px}\n", ""]);

// Exports
exports.locals = {
	"value": "value-4850abc6",
	"apply": "apply-13e5984f"
};